interface ConfirmModalProps {
  isOpen: boolean
  title?: string
  children?: React.ReactNode
  confirmLabel?: string
  /** 미전달 시 취소 버튼 숨김 — 확인 버튼만 있는 알림 모달로 동작 */
  cancelLabel?: string
  onConfirm: () => void
  onCancel?: () => void
  /** 확인 버튼 색상 — 삭제 등 위험 동작은 'red', 기본은 'white' */
  confirmColor?: 'white' | 'red'
}

export const ConfirmModal = ({
  isOpen,
  title,
  children,
  confirmLabel = '확인',
  cancelLabel,
  onConfirm,
  onCancel,
  confirmColor = 'white',
}: ConfirmModalProps) => {
  if (!isOpen) return null

  const confirmBtnBase =
    'flex flex-1 items-center justify-center py-4 rounded-full font-pretendard font-semibold text-sm tracking-[-0.35px] transition-colors cursor-pointer select-none'

  const confirmBtnStyle =
    confirmColor === 'red'
      ? 'bg-primary-error border border-primary-error text-font-basic hover:bg-primary-hover-red'
      : 'bg-font-basic border border-font-basic text-font-black hover:bg-gray-200'

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center"
    >
      {/* 오버레이 */}
      <div
        className="absolute inset-0 bg-[rgba(0,0,0,0.55)]"
        onClick={cancelLabel ? onCancel : onConfirm}
        aria-hidden="true"
      />

      {/* 모달 카드 */}
      <div className="relative z-10 w-[312px] flex flex-col items-start overflow-hidden rounded-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.98),0px_0px_18px_0px_rgba(0,0,0,0.78)]">
        {/* 카드 배경 */}
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-bg-grey rounded-[16px] pointer-events-none"
        />

        {/* 본문 영역 */}
        <div className="relative flex flex-col items-center justify-center w-full">
          {/* 텍스트 행 */}
          <div className="flex flex-col items-start py-4 w-full">
            <div className="flex flex-col gap-2 items-start pt-4 px-4 w-full">
              {/* title */}

              {title && (
                <p className="w-full font-pretendard font-normal text-[16px] text-font-basic tracking-[-0.3px] leading-normal text-center">
                  {title}
                </p>
              )}
              {/* children — 줄바꿈 등 자유로운 description */}
              {children && (
                <div className="w-full font-pretendard font-normal text-[16px] text-font-basic tracking-[-0.3px] leading-normal text-center">
                  {children}
                </div>
              )}
            </div>
          </div>

          {/* 버튼 행 */}
          <div className="flex items-center justify-center py-6 w-full">
            <div className="flex flex-1 gap-4 items-center px-4">
              {/* 취소 버튼 — cancelLabel 없으면 숨김 */}
              {cancelLabel && (
                <button
                  type="button"
                  onClick={onCancel}
                  className="flex flex-1 items-center justify-center py-4 rounded-full border border-font-basic text-font-basic font-pretendard font-semibold text-sm tracking-[-0.35px] transition-colors cursor-pointer select-none hover:bg-font-basic/10"
                >
                  {cancelLabel}
                </button>
              )}

              {/* 확인 버튼 */}
              <button
                type="button"
                onClick={onConfirm}
                className={`${confirmBtnBase} ${confirmBtnStyle}`}
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>

        {/* 인셋 테두리 */}
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_2px_0px_rgba(255,255,255,0.18)]" />
      </div>
    </div>
  )
}
